import { configureStore } from '@reduxjs/toolkit';
import Reducer1 from './PlayReelSlice';

import Reducer10 from './LoaderRun';
import Reducer11 from './ImageWorkHeight';

export default configureStore({
  reducer: {
    screen: Reducer1,

    loaderRuned: Reducer10,
    HeightEstado: Reducer11,
  },
});
